import { createSlice } from '@reduxjs/toolkit'

import { SessionGetCreateResponse } from '@api/orval/apiHooks'
import type { RootState } from '@store/store'

interface SessionState {
  user: SessionGetCreateResponse | null
}

const initialState: SessionState = {
  user: null,
}

// Slice
const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession(state, { payload }: { payload: SessionGetCreateResponse | null }) {
      state.user = payload
    },
    signOut(state) {
      state.user = null
    },
  },
})

// Selectors
export const selectCurrentUser = (s: RootState) => s.session.user
export const selectCurrentUserEmail = (s: RootState) => s.session.user?.email
export const selectCurrentUserTimezone = (s: RootState) => s.session.user?.timezone

// Actions
export const { signOut, setSession } = sessionSlice.actions
export const sessionReducer = sessionSlice.reducer
